import { ICacheController } from "./ICacheController";

import { GoodgameBitmapEngine } from "../GoodgameBitmapEngine";
import { IClipSource } from "../clipsource/IClipSource";
import { ClipColor } from "../components/ClipColor";

import Bitmap = createjs.Bitmap;

/**
 * controller to handle cached ClipSpources for GoodgameBitmapClip
 */
export class ClipCacheController implements ICacheController {
    public bitmapCache: Map<string, Bitmap[]> = new Map();
    /** contains all cached classes. key is a chacheID String */
    private globalCache: Map<any, any> = new Map<any, any>();
    private maxCacheItems: number = 5;

    /** returns IClipSource from cache */
    public getCache(id: string, clipColor: ClipColor[] = null): IClipSource {
        let cacheVector: IClipSource[] = this.globalCache.get(id);
        if (!cacheVector || (cacheVector && cacheVector.length < 1)) {
            return null;
        }
        if (clipColor) {
            return this.getClipSourceByColorID(cacheVector, this.getColorIDByColorVector(clipColor));
        }
        else {
            return cacheVector[0];
        }
    }

    private getColorIDByColorVector(clipColor: ClipColor[] = null): string {
        if (clipColor && clipColor.length > 0) {
            let colorIDString: string = "";
            for (let i: number = 0; i < clipColor.length; i++) {
                colorIDString += clipColor[i].colorID;
            }
            return colorIDString;
        }
        else {
            return null;
        }
    }

    /** adds a IClipSource to cache */
    public addToCache(id: string, source: IClipSource): void {
        let cacheVector: IClipSource[] = this.globalCache.get(id);
        if (!cacheVector) {
            this.globalCache.set(id, cacheVector = []);
        }
        if (this.getClipSourceByColorID(cacheVector, source.colorID) == null) {
            if (cacheVector.length >= this.maxCacheItems) {
                cacheVector.shift();
            }
            cacheVector.push(source);
        }
    }

    public removeFromCache(id: string): void {
        if (this.globalCache.get(id)) {
            let cacheVector: IClipSource[] = this.globalCache.get(id);
            this.globalCache.delete(id);
        }
    }

    private getClipSourceByColorID(cacheVector: IClipSource[], colorID: string): IClipSource {
        for (let clipSource of cacheVector) {
            if (clipSource.colorID == colorID) {
                return clipSource;
            }
        }
        return null;
    }

    /** will be called if cache controller component will be switched. to make a clean removal of current cache controller. */
    public dispose(): void {
        // TODO: @HTML5
        //GoodgameBitmapEngine.bulkLoader.removeAll();
        for (let key of Array.from(this.globalCache.keys())) {
            let clipSourceVector: IClipSource[] = this.globalCache.get(key) as IClipSource[];

            for (let clipSource of clipSourceVector) {
                if (clipSource) {
                    clipSource.destroy();
                }
            }
        }
        this.globalCache = new Map<any, any>();
    }
}
